import { useGetRfiTypes } from './queries/rfiTypesQueries';
import { RfiType } from '../sdk/types';

type UseGetRfiTypeNameReturn = {
  isLoading: boolean;
  isError: boolean;
  rfiTypeName: string;
};

export const useGetRfiTypeName = (rfiTypeId: RfiType['id']): UseGetRfiTypeNameReturn => {
  const { data: rfiTypes, isError } = useGetRfiTypes();

  const isLoading = !rfiTypes || rfiTypes.length === 0;

  const rfiTypeName = rfiTypes?.find(({ id }) => id === rfiTypeId)?.name || '-';

  return {
    isLoading,
    isError,
    rfiTypeName,
  };
};
